import { gql } from 'apollo-angular';

export const RequestPasswordResetDocument = gql(/* GraphQL*/ `mutation requestPasswordReset($email: String!)
{
  requestPasswordReset(email: $email)
}
`);
